import { getLocale } from "../runtime";

const sv_icontranslate = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Översätt`
};

const icontranslate = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_icontranslate(inputs)
	return "iconTranslate";
};

export { icontranslate as "iconTranslate" };